module.exports = __webpack_public_path__ + "img/2_bronze.a58c0d11.svg";